// src/store/authStore.js
import {
    create
} from 'zustand';
import {
    persist
} from 'zustand/middleware';

const useAuthStore = create(
    persist(
        (set) => ({
            access: null,
            refresh: null,
            orgId: null,
            setAccess: (access) => set({
                access
            }),
            setRefresh: (refresh) => set({
                refresh
            }),
            setOrgId: (orgId) => set({
                orgId
            }),
            logout: () => set({
                access: null,
                refresh: null,
                orgId: null
            }),
        }), {
            name: 'auth-storage',
        }
    )
);

export default useAuthStore;